'use client'

import { useTranslations } from 'next-intl'
import { ReactNode } from 'react'
import { toast } from 'react-toastify'

import { TextButton } from '@/shared/ui'

import { copy } from './copy'
import { passPropsToChildren } from '../render'

type Props = {
  value: string
  successMessage?: string
  onSuccess?: () => void
  asChild?: boolean
  children?: ReactNode
}

export const CopyButton = ({
  value,
  successMessage,
  onSuccess,
  asChild,
  children,
}: Props) => {
  const t = useTranslations('lease.room_info')

  const handleButtonClick = async () => {
    const { success } = await copy(value)

    if (success) {
      if (successMessage) toast(successMessage)
      onSuccess?.()
    }
  }

  if (asChild) {
    return passPropsToChildren(children, {
      onClick: handleButtonClick,
    })
  }

  return (
    <TextButton color="blue" onClick={handleButtonClick} className="h-fit">
      {t('copy')}
    </TextButton>
  )
}
